// extracted by mini-css-extract-plugin
export var centerText = "_8u-8";
export var container = "_8u-0";
export var doughnutContainer = "_8u-7";
export var legend = "_8u-a";
export var legendItemColorDisplay = "_8u-b";
export var legendItemLabel = "_8u-d";
export var legendItemValue = "_8u-c";
export var lg = "_8u-5";
export var maxWidth = "_8u-9";
export var md = "_8u-4";
export var responsive = "_8u-6";
export var sm = "_8u-3";
export var xs = "_8u-2";
export var xxs = "_8u-1";